import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as selectors from '../../reducers';
import { setActivePage, setComparedRegion } from '../../actions/ui';
import styles from './compare-select-page.module.scss';
import Button from '../../components/button';
import classNames from 'classnames';
class CompareSelectPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCouncil: null,
    };
    this.goToRegionPage = this.goToRegionPage.bind(this);
    this.showComparison = this.showComparison.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
  }
  goToRegionPage() {
    const { setActivePage } = this.props;
    setActivePage('region');
  }

  showComparison() {
    const { setComparedRegion } = this.props;
    const { selectedCouncil } = this.state;
    if (!selectedCouncil) return;
    setComparedRegion(selectedCouncil.value);
    this.goToRegionPage();
  }

  onSelectChange(council) {
    this.setState({ selectedCouncil: council });
  }

  renderCouncils(regions) {
    const { selectedCouncil } = this.state;
    return regions.map(region => {
      return (
        <div
          key={region.id}
          role="button"
          onClick={e => {
            this.setState({
              selectedCouncil: {
                label: region.name,
                value: region.id,
              },
            });
          }}
          className={classNames({
            [styles.listItem]: true,
            [styles.listItemActive]: selectedCouncil
              ? selectedCouncil.value === region.id
              : false,
          })}
        >
          {region.name}
        </div>
      );
    });
  }

  renderOtherRegions() {
    const { regions, activeRegion } = this.props;
    const classificationCouncils = regions.filter(council => {
      return (
        council.id !== activeRegion.id &&
        council.classification === activeRegion.classification &&
        council.compare
      );
    });

    return (
      <div>
        <h4 className={styles.classificationHeadline}>
          {activeRegion.classification}
        </h4>
        <div className={styles.councilList}>
          {this.renderCouncils(classificationCouncils)}
        </div>
      </div>
    );
  }

  renderRegionList() {
    return this.renderOtherRegions();
  }

  renderButtonRow() {
    const { selectedCouncil } = this.state;
    return (
      <div className={styles.buttonsRow}>
        <button
          type="button"
          className={styles.backLink}
          onClick={this.goToRegionPage}
        >
          <img
            className={styles.backLinkImage}
            src={`${process.env.PUBLIC_URL}/img/close-icon.svg`}
            alt="chevron icon"
          />
          close
        </button>
        <Button disabled={!selectedCouncil} whenOnClick={this.showComparison}>
          show comparison
        </Button>
      </div>
    );
  }

  render() {
    const { activeRegion } = this.props;
    return (
      <div className={styles.compareSelectPageWrapper}>
        {this.renderButtonRow()}
        <div className={styles.heading}>{activeRegion.name}</div>
        <h3 className={styles.chooseHeadline}>Choose a region to compare</h3>
        <div className={styles.formWrapper}>
          <form>
            {this.renderRegionList()}
          </form>
        </div>
        {this.renderButtonRow()}
      </div>
    );
  }
}

const mapDispatchToProps = {
  setActivePage,
  setComparedRegion,
};

const mapStateToProps = state => ({
  activeRegion: selectors.getActiveCouncil(state),
  regions: selectors.getRegions(state),
});

CompareSelectPage.propTypes = {
  regions: PropTypes.arrayOf(PropTypes.object),
  activeRegion: PropTypes.object.isRequired,
  setActivePage: PropTypes.func.isRequired,
  setComparedRegion: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompareSelectPage);



// WEBPACK FOOTER //
// ./src/pages/compare-select-page/compare-select-page.js